/** تاريخ محلي بصيغة YYYY-MM-DD (مناسب لـ query ?date=) */
export function formatLocalDateYYYYMMDD(date = new Date()) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
